// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__K8rNz","divider":"Footer_divider__hjOJY","terms":"Footer_terms__oGf0O"};